import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { GetStdTurnDetail } from 'src/app/_Models/AD/ADSTD/ADSTD0501/getStdTurnDetail';
import { GetStdTurnList } from 'src/app/_Models/AD/ADSTD/ADSTD0501/getStdTurnList';
import { GetStdTurnListInput } from 'src/app/_Models/AD/ADSTD/ADSTD0501/getStdTurnListInput';
import { GetClassList } from 'src/app/_Models/getClassList';
import { GetDeptList } from 'src/app/_Models/getDeptList';
import { GetEduList } from 'src/app/_Models/getEduList';
import { GetSelectList } from 'src/app/_Models/getSelectList';
import { GetSTDStatusList } from 'src/app/_Models/getSTDStatusList';
import { GetTeamList } from 'src/app/_Models/getTeamList';
import { SystemService } from 'src/app/_Services/_Shared/system.service';
import { InitialData } from 'src/app/_SharedFunctions/initialData';
import { environment } from 'src/assets/environments/environment';
import { IAttachment } from '../../../_Models/AD/ADSYS/ADSYS0501/IPost_DeptModel';
import { FileExchange } from 'src/app/_SharedFunctions/fileExcange';
import Swal from 'sweetalert2';
import { AttachmentModel } from 'src/app/_Models/AD/ADSTD/ADSTD0501/AttachmentModel';

@Component({
    selector: 'app-ADSTD0501ISU01',
    templateUrl: './ADSTD0501ISU01.component.html',
    styleUrls: ['./ADSTD0501ISU01.component.css']
})
export class ADSTD0501ISU01Component implements OnInit {
    term = require('src/app/_Models/_SelectInput/term.json').term;
    Years!: Array<string>;
    baseUrl = environment.apiUrl;
    bsConfig = environment.bsDatePickerConfig;
    modalRef!: BsModalRef;
    dataKeyArray: Array<string> = [];
    sTDStatusList!: GetSTDStatusList[];
    initialData = new InitialData(this.http);
    eduList!: GetEduList[];
    deptList!: GetDeptList[];
    newdeptList!: GetDeptList[];
    classList!: GetClassList[];
    stdTurnReason!: GetSelectList[];
    teamList!: GetTeamList[];
    stdTurnListInput: GetStdTurnListInput = {
        TurnYear: '',
        TurnTerm: '',
        Approve: '',
        EduNo: '',
        DeptNo: '',
        TeamNo: '',
        Class: '',
        Status: '',
        IDNo: '',
        StdNo: '',
        StdName: ''
    };
    stdTurnList!: GetStdTurnList[];
    stdTurnDetail!: GetStdTurnDetail;
    Attachment: IAttachment[] = [];
    fileExchange = new FileExchange();


    //匯入附件
    detailData: AttachmentModel = {

        Attachment: []
    };

    constructor(private http: HttpClient,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private systemService: SystemService,
        private localeService: BsLocaleService,) { }

    ngOnInit(): void {
        this.localeService.use('zh-cn');
        this.getYears();
        this.getSTDStatusList();
        this.getEduList();
        this.getAllDeptList();
        this.getStdTurnReason();
    }

    getStdTurnReason() {
        this.systemService.getStdTurnReason().subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
            }
            this.stdTurnReason = response;
        }, error => this.toastr.error(error.error));
    }

    getYears() {
        this.initialData.getYears().subscribe((response) => {
            if (response) {
                this.Years = response;
            }
        });
    }

    getSTDStatusList() {
        this.systemService.getSTDStatusList().subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.sTDStatusList = response;
        }, error => this.toastr.error(error.error))
    }


    getEduList() {
        this.systemService.getEduList('3', '', '', 'Y').subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.eduList = response;

        }, error => this.toastr.error(error.error))
    }

    getDeptList(edu: string) {
        this.systemService.getDeptList(edu, '3', '', '', 'Y', '').subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.deptList = response;

        }, error => this.toastr.error(error.error));
    }

    getAllDeptList() {
        this.systemService.getDeptList('', '3', '', '', 'Y', '').subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.newdeptList = response;

        }, error => this.toastr.error(error.error));
    }

    getClassList(edu: string, dept: string) {
        this.classList=[];
        this.systemService.getClassList(edu, dept, '3', '', '', 'Y', '').subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.classList = response;

        }, error => this.toastr.error(error.error))
    }

    getTeamList(dept: string) {
        this.teamList=[];
        this.systemService.getTeamList('3', '', '', dept, '').subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.teamList = response;
        });
    }

    getStdTurnList() {
        this.http.post<any>(this.baseUrl + "ACAD/STD/ADSTD05_01ISU/Get_StdTurn_List", this.stdTurnListInput).subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                this.stdTurnList = []
                return;
            }
            this.stdTurnList = response;
            this.stdTurnList.forEach(element => {
                element.checked = false;
            });
        })
    }

    getStdTurnDetail(isNew: boolean, dataKey: string, template: TemplateRef<any>) {

        this.stdTurnDetail = {
            DataKey: '',
            TurnYear: '',
            TurnTerm: '',
            StdNo: '',
            StdName: '',
            ClassName: '',
            TurnNo: '',
            ApplyDate: '',
            Memo: '',
            ApproveDate: '',
            Approve: '',
            TurnDeptNo: '',
            TurnTeamNo: '',
            TurnClass: '',
            DeptNo: '',
            TeamNo: '',
            Class: '',
            ContrastYear:'',
            PrimaryContrastYear:'',
            ExtraTerms:0
        }

        if (!isNew) {
            this.http.post<any>(this.baseUrl + "ACAD/STD/ADSTD05_01ISU/Get_StdTurn_Detail", { DataKey: dataKey }).subscribe((response) => {
                if (response.Info == false) {
                    this.toastr.warning(response.Message);
                    return;
                }
                this.stdTurnDetail = response;
                console.log(this.stdTurnDetail);
            })
        }

        let modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-xl'
        };

        this.getClassList('', this.stdTurnDetail.TurnDeptNo);
        this.getTeamList(this.stdTurnDetail.TurnDeptNo);

        this.modalRef = this.modalService.show(template, modalConfig);

    }

    setDatakey(type: string, dataKey: string, event: any) {
        if (!this.stdTurnList) {
            return;
        }
        let input = <HTMLInputElement>event;
        if (type == 'all') {
            if (this.dataKeyArray.length != this.stdTurnList.length && input.checked == true) {
                this.dataKeyArray = [];
                this.stdTurnList.forEach(element => {
                    this.dataKeyArray.push(element.DataKey);
                    element.checked = true;
                })
            }
            else {
                this.dataKeyArray = [];
                this.stdTurnList.forEach(element => {
                    element.checked = false;
                })
            }
        }
        else {
            let index = this.dataKeyArray.indexOf(dataKey);
            if (index == -1) {
                this.dataKeyArray.push(dataKey);
            }
            else {
                this.dataKeyArray.splice(index, 1);
            }
        }
    }

    getStdTurnModify() {

        if (this.stdTurnDetail.StdNo == '') {
            this.toastr.info("未設定學生");
            return;
        }

        if (this.stdTurnDetail.TurnYear == '' ||
            this.stdTurnDetail.TurnTerm == '' ||
            this.stdTurnDetail.TurnDeptNo == '' ||
            this.stdTurnDetail.TurnClass == '') {
            this.toastr.info("必填欄位請填妥");
            return;
        }

        this.http.post<any>(this.baseUrl + "ACAD/STD/ADSTD05_01ISU/Get_StdTurn_Modify", this.stdTurnDetail).subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.toastr.success("儲存成功");
            this.getStdTurnList()
            this.modalRef.hide();
        })
    }

    getStdTurnDelete() {
        if (this.dataKeyArray.length == 0) {
            this.toastr.info("請先選擇學生");
            return;
        };

        Swal.fire({
            title: `確定刪除${this.dataKeyArray.length}筆資料?`,
            showDenyButton: true,
            confirmButtonText: '是',
            denyButtonText: '否',
        }).then((result) => {
            if (result.isConfirmed) {
                let dataKey = '';
                this.dataKeyArray.forEach(element => {
                    dataKey = dataKey + element + ',';
                });

                this.http.post<any>(this.baseUrl + "ACAD/STD/ADSTD05_01ISU/Get_StdTurn_Delete", { DataKey: dataKey.substring(0, dataKey.length - 1) }).subscribe((response) => {
                    if (response.Info == false) {
                        this.toastr.warning(response.Message);
                        return;
                    }
                    this.toastr.success("刪除成功");
                    this.dataKeyArray = [];
                    this.getStdTurnList();
                })
            }
            else if (result.isDenied) {
                this.toastr.info("已取消動作");
            }
        });
    }

    Base64:any = "" ;
    //上傳
    async importData($event: any) {
        //this.Attachment = [];
        let file = $event.target.files;
        if (file.length == 0) return;


        //for (let i = 0; i < file.length; i++) {
            let fileBase64 = await this.fileExchange.FileToBase64String(file[0]);
            //this.Attachment?.push({ FileName: file[i].name, Base64: fileBase64 });
        //}

        this.Base64 = { FileName: file[0].name, Base64: fileBase64 } ;
        console.log(this.Base64)
    }


    import(isNew: boolean, dataKey: string, template: TemplateRef<any>) {
        this.stdTurnDetail = {
            DataKey: '',
            TurnYear: '',
            TurnTerm: '',
            StdNo: '',
            StdName: '',
            ClassName: '',
            TurnNo: '',
            ApplyDate: '',
            Memo: '',
            ApproveDate: '',
            Approve: '',
            TurnDeptNo: '',
            TurnTeamNo: '',
            TurnClass: '',
            DeptNo: '',
            TeamNo: '',
            Class: '',
            ContrastYear:'',
            PrimaryContrastYear:'',
            ExtraTerms:0
        }

        if (!isNew) {
            this.http.post<any>(this.baseUrl + "ACAD/STD/ADSTD05_01ISU/Get_StdTurn_Detail", { DataKey: dataKey }).subscribe((response) => {
                if (response.Info == false) {
                    this.toastr.warning(response.Message);
                    return;
                }
                this.stdTurnDetail = response;
                console.log(this.stdTurnDetail);
            })
        }

        let modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-xl'
        };

        this.getClassList('', this.stdTurnDetail.TurnDeptNo);
        this.getTeamList(this.stdTurnDetail.TurnDeptNo);

        this.modalRef = this.modalService.show(template, modalConfig);
    }

    //匯入資料
    InsertPost(): void {

        this.detailData.Attachment = [];
        this.detailData.Attachment = this.Attachment;
        console.log(this.detailData.Attachment)
        this.http.post<any>(this.baseUrl + "ACAD/STD/ADSTD05_01ISU/Import_WeakFile_Base64", this.Base64).subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }

            this.toastr.success("新增成功");
            this.modalRef?.hide();
        });

    }


}
